import { NewsCard } from '@/modules/homepage/NewsCard/NewsCard';
import { SmallNewsCard } from '@/modules/homepage/SmallNewsCard/SmallNewsCard';
import { NewsFormatType } from '@/types/homepage.types';
import getPickleballCentralCDNURL from '@/utils/helpers/getPickleballCentralCDNURL';

export interface RenderExternalNewsProps {
  url: string;
  newsType: NewsFormatType;
  title?: string;
  image?: string;
  description?: string;
  datePublished?: string;
  author?: string;
}

export const RenderExternalNews = ({
  url,
  title,
  description,
  image,
  author,
  datePublished,
  newsType,
}: RenderExternalNewsProps) => {
  if (title && image) {
    return (
      <a
        className='cursor-pointer hover:opacity-80'
        href={url}
        rel='noopener noreferrer'
        target='_blank'
        aria-label={`Link to ${title} (opens in a new tab)`}
      >
        {newsType === 'format-a' ? (
          <NewsCard
            url={url}
            image={getPickleballCentralCDNURL(image, 650, 260)}
            description={description}
            title={title}
            author={author}
            externalNews
            {...(datePublished ? { publishDateDisplayed: datePublished } : {})}
          />
        ) : (
          <SmallNewsCard
            url={url}
            image={getPickleballCentralCDNURL(image, 650, 260)}
            description={description}
            title={title}
            author={author}
            externalNews
            {...(datePublished ? { publishDateDisplayed: datePublished } : {})}
          />
        )}
      </a>
    );
  }

  return null;
};
